import axios, { AxiosRequestHeaders } from "axios";
import { ChangeEventHandler, useState } from "react";
import { artistCatIds } from "../../../data-for-test";
import { ILoginData2 } from "../../../models";
import { HOSTNAME } from "../api-utils";
import { ApiTesterComponent, IApiFetcher } from "../ApiTesterApp";

export const fetcher: IApiFetcher = async ({
  artist_id,
  utoken,
  omitUserAgent = false,
}: {
  artist_id: number;
  utoken: string;
  omitUserAgent?: boolean;
}) => {
  const headers: AxiosRequestHeaders = {};
  if (!omitUserAgent) {
    headers["User-Agent"] = "I:2.5.0(256)";
  }
  headers["utoken"] = utoken;

  const response = await axios.get<any>(`${HOSTNAME}${fetcher.url}`, {
    headers,
    params: {
      artist_id
    }
  });
  return response.data;
};
fetcher.url = "/wp-json/wp/v3/artists/get_short";
fetcher.method = 'GET';

const ArtistsGetShort: ApiTesterComponent = ({
  loginData,
}: {
  loginData: ILoginData2 | null;
}) => {
  const [data, setData] = useState<string>("");
  const [artistId, setArtistId] = useState<string>("0");
  const [loading, setIsLoading] = useState<boolean>(false);

  const onFetch = () => {
    if (!loginData?.token) return;

    setIsLoading(true);
    fetcher({
      artist_id: +artistId,
      utoken: loginData.token,
      omitUserAgent: true,
    }).then((data) => {
      setIsLoading(false);
      setData(JSON.stringify(data, null, 2));
    });
  };

  const onArtistChange: ChangeEventHandler<HTMLSelectElement> = (e) => {
    setArtistId(e.target.value);
  };

  return (
    <div>
      <h3>ArtistsGetShort</h3>

      <select value={artistId} onChange={onArtistChange}>
        <option key="0" value="0">
          None
        </option>
        {artistCatIds.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
      <button onClick={onFetch}>Fetch</button>
      <pre>{loading ? "Loading..." : data}</pre>
    </div>
  );
};

ArtistsGetShort.fetcher = fetcher;

export default ArtistsGetShort;
